module.exports = __webpack_public_path__ + "11_hair_black.12c89a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/11_hair_black.png
// module id = 9DMW
// module chunks = 0